import React from "react";

import {
  Box,
  InputAdornment,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { fade, makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";

import FilterButton from "../../components/FilterButton";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    minWidth: 0,
    flex: 1,
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
    },
    [theme.breakpoints.down("xs")]: {
      display: "grid",
      gridTemplateColumns: "minmax(0, 1fr) auto",
      alignItems: "center",
    },
  },
  pipeline: {
    width: 240,
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      gridColumn: "1 / -1",
    },
  },
  search: {
    flex: "1 1 280px",
    minWidth: 220,
    [theme.breakpoints.down("xs")]: {
      minWidth: 0,
      width: "100%",
    },
  },
  field: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      backgroundColor: theme.palette.background.paper,
      "& fieldset": {
        borderColor: fade(theme.palette.divider, 0.92),
      },
      "&:hover fieldset": {
        borderColor: fade(theme.palette.primary.main, 0.4),
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
        borderWidth: 1,
      },
    },
  },
}));

const CrmToolbar = ({
  pipelines,
  selectedPipelineId,
  searchParam,
  filterCount,
  filtersOpen,
  loadingPipelines,
  onPipelineChange,
  onSearchChange,
  onToggleFilters,
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <TextField
        className={`${classes.field} ${classes.pipeline}`}
        select
        variant="outlined"
        size="small"
        label="Pipeline"
        value={selectedPipelineId}
        onChange={(event) => onPipelineChange(event.target.value)}
        disabled={loadingPipelines}
      >
        {pipelines.length === 0 ? (
          <MenuItem value="">Nenhum funil cadastrado</MenuItem>
        ) : null}
        {pipelines.map((pipeline) => (
          <MenuItem key={pipeline.id} value={pipeline.id}>
            {pipeline.name}
            {pipeline.isActive === false ? " (inativo)" : ""}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        className={`${classes.field} ${classes.search}`}
        variant="outlined"
        size="small"
        label="Busca"
        placeholder="Titulo, contato ou telefone"
        value={searchParam}
        onChange={(event) => onSearchChange(event.target.value)}
        inputProps={{ "aria-label": "Buscar negocios" }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
        }}
      />

      <FilterButton
        count={filterCount}
        open={filtersOpen}
        controls="crm-advanced-filters"
        onClick={(event) => onToggleFilters(event)}
      />
    </Box>
  );
};

export default CrmToolbar;
